import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'keyFeatureFilter',
    pure: true
})
export class BDCPKeyFeatureFilterPipe implements PipeTransform {

    public transform(keyFeatures: string[], max: number): string[] {
        if (!Array.isArray(keyFeatures)) {
            return []; // Return an empty array if keyFeatures is not iterable
        }
        const newKeyFeatures: string[] = [];
        for (const keyFeature of keyFeatures) {
            const trimmed = keyFeature.replace(/\n/ig, '').replace('↵', '').trim();
            if (trimmed === '') {
                continue;
            }
            newKeyFeatures.push(trimmed);
            if (newKeyFeatures.length === max) {
                break;
            }
        }
        return newKeyFeatures;
    }

}
